import { render, staticRenderFns } from "./vendorEventParticipation.vue?vue&type=template&id=55becb04&scoped=true"
import script from "./vendorEventParticipation.vue?vue&type=script&lang=js"
export * from "./vendorEventParticipation.vue?vue&type=script&lang=js"
import style0 from "./vendorEventParticipation.vue?vue&type=style&index=0&id=55becb04&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55becb04",
  null
  
)

export default component.exports